import Header from '../../../components/header';
import ProductItem from '../../../module/dashboard/products/productItem';
import {useLocalStorage} from '../../../utilities/hooks/useLocalStorage';
import EmptyList from '../../../assets/image/shared/empty_list.svg';

const Bookmarks = () => {
  const [bookmarks] = useLocalStorage('bookmarks', []);
  return (
    <>
      <Header title="آگهی های نشان شده" />
      {bookmarks.length === 0 && (
        <>
          <div className="mt-5 pt-5 text-center">
            <img src={EmptyList} alt="موردی برای نمایش موجود نیست" />
          </div>
        </>
      )}
      {(bookmarks as TPost[])?.reverse().map(item => (
        <ProductItem
          icon={item?.input_group?.icon}
          inputGroupType={item?.input_group?.code}
          post={item}
        />
      ))}
    </>
  );
};

export default Bookmarks;
